import React from 'react';
import './DataAnalytics.css';

function DataAnalytics() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Data & Analytics</h1>
        <p className="lead">Transform data into actionable insights</p>
      </div>
      
      <div className="content-section">
        <div className="row">
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Data Visualization</h3>
                <p>Create intuitive visual representations of data</p>
                <i className="bi bi-pie-chart feature-icon"></i>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Predictive Analytics</h3>
                <p>Forecast trends and future outcomes</p>
                <i className="bi bi-graph-up-arrow feature-icon"></i>
              </div>
            </div>
          </div>
          
          <div className="col-md-4">
            <div className="card feature-card">
              <div className="card-body">
                <h3>Business Intelligence</h3>
                <p>Generate actionable business insights</p>
                <i className="bi bi-briefcase feature-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataAnalytics;
